import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { SliceQuery } from '../api/api.defs';
import { SettingsRow } from './settings.defs';
import { environment } from 'src/environments/environment';
import { tap, map } from 'rxjs/operators';
import { OfflineService } from '../api/offline.service';

@Injectable({
	providedIn: 'root'
})
export class SettingsService {

	constructor(
		private _api: ApiService,
		private _offline: OfflineService,
	) { }

	active: SettingsRow;

	getRequest(date: Date) {
		return {'$/slice/report': {
			slice: environment.slices.settings,
			where: ['$and',
				['$lte', ['$date', ['$field', 'active']], ['$date', date]],
			],
			order: [['$desc', ['$field', 'active']]],
			limit: 1,
		}}
	}

	fetch(date = new Date()) {
		date.setHours(0,0,0,0);
		const key = `settings.fetch.${this._offline.dateAsString(date)}`;
		return this._api
			.request<SliceQuery<SettingsRow>>(this.getRequest(date), key)
			.pipe(
				map(resp => resp.rows.pop()),
				tap(s => this.active = s),
			)
	}
}
